module.exports = __webpack_public_path__ + "static/media/logo_white.edb44e56.svg";